<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="挖掘宝藏" @back="goBack" /></span>
          <el-card style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel ref="CommonExcelRef" :import-p="'config:rewardRunForItEdit:import'" :export-p="'config:rewardRunForItEdit:export'" :import-method="importBaseCfg" :export-method="exportBaseCfg" />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template slot-scope="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="最小等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.minLv" placeholder="最小等级" />
                </template>
              </el-table-column>
              <el-table-column align="center" label="最大等级" width="150">
                <template slot-scope="{row, $index}">
                  <el-input v-model="row.maxLv" placeholder="最大等级" />
                </template>
              </el-table-column>
              <el-table-column label="用户分组" min-width="100%" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.groupIds" multiple>
                    <el-option v-for="item in groupsList" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="兑换类型" width="150" align="center">
                <template slot-scope="{row, $index}">
                  <el-select v-model="row.exchangeType" style="width: 100%;" placeholder="请选择">
                    <el-option v-for="item in exchangeOptions" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="兑换比例" width="150" align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.exchangeRate" placeholder="兑换比例" />
                </template>
              </el-table-column>
              <el-table-column label="关卡配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.stageId">
                    <el-option v-for="item in list[1]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="商品配置" align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.goodsId">
                    <el-option v-for="item in list[2]" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="100">
                <template slot-scope="{row,$index}">
                  <el-button v-permisaction="['config:rewardRunForItEdit:del']" size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button v-permisaction="['config:rewardRunForItEdit:add']" type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-permisaction="['config:rewardRunForItEdit:add']" type="primary" :disabled="isOnline === 1" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </div>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import { getActivtyList, updateActivtyRewardConfData } from '@/api/config/activity-cfg'
import CommonExcel from '@/components/CommonExcel/index.vue'
import { downloadExcelMultiSheet } from '@/utils/excel'
export default {
  name: 'DiggingTreasureEdit',
  components: { CommonExcel },
  data() {
    return {
      mapDialog: false,
      mapDialogList: [],
      mapDialogIndex: -1,
      list: [],
      baseList: [],
      groupsList: [{ name: '默认分组', id: 0 }],
      isOnline: 0,
      curClass: 'digging_treasure',
      exchangeOptions: [
        { label: '金币', value: 14 },
        { label: '体力', value: 15 }
      ]
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.init()
  },
  methods: {
    init() {
      this.getActivity()
      this.getList()
      this.initBase()
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 1 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], stageId: 0, goodsId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    handleSaveBase() {
      for (const i in this.baseList) {
        const val = this.baseList[i]
        if (!val.groupIds) {
          this.msgError('请选择分组')
          return
        }
      }
      updateActivtyRewardConfData({ name: this.aid, data: JSON.stringify(this.baseList) }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActivity() {
      getActivtyList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.baseList = res.data.list[0].reward_conf
          if (!this.baseList) {
            this.baseList = []
          }
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, stageId: this.list[1], goodsId: this.list[2] }, true, 'name', 'id')
        break
      }
    },
    exportBaseCfg() {
      const fileName = '挖掘宝藏活动配置'
      const hearer = []
      const excelData = []
      const name = ['挖掘宝藏活动配置']
      const list = this.$refs.CommonExcelRef.tranToTarget(this.baseList, { groupIds: this.groupsList, stageId: this.list[1], goodsId: this.list[2] }, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, { minLv: '最小等级', maxLv: '最大等级', groupIds: { name: '用户分组', sub: [] }, stageId: '关卡配置', goodsId: '商品配置', exchangeRate: '兑换比例' })
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    }
  }
}
</script>

<style scoped>
</style>
